module.exports = __webpack_public_path__ + "img/bluecirclesm.eb033ee4.webp";